import src from "IMAGE";
export default { src, width: 408, height: 252, blurWidth: 0, blurHeight: 0};
